// Modul belajar Matematika – elemen Bilangan.
// Format modul & langkah dijelaskan di src/belajar/README.md.
import { fracBar } from '../../subjects/matematika/gambar.js';
import { F } from '../../core/format.js';

const IKON_URUTAN = '<svg viewBox="0 0 64 64"><path d="M6 40H58" stroke="var(--edge)" stroke-width="4" stroke-linecap="round"/><path d="M8 34v12M56 34v12" stroke="var(--edge)" stroke-width="3" stroke-linecap="round"/><rect x="12" y="12" width="14" height="18" rx="4" fill="var(--sky)" stroke="var(--edge)" stroke-width="3"/><rect x="38" y="6" width="14" height="24" rx="4" fill="var(--pink)" stroke="var(--edge)" stroke-width="3"/><path d="M19 30v10M45 30v10" stroke="var(--edge)" stroke-width="3"/><path d="M24 54h16l-4-4M40 54l-4 4" fill="none" stroke="var(--grape)" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>';
const IKON_PERSEN = '<svg viewBox="0 0 64 64"><path d="M10 12h28l18 20-18 20H10Z" fill="var(--sun)" stroke="var(--edge)" stroke-width="3" stroke-linejoin="round"/><circle cx="17" cy="32" r="3.5" fill="var(--surface)" stroke="var(--edge)" stroke-width="2.5"/><circle cx="29" cy="24" r="4" fill="none" stroke="var(--edge)" stroke-width="3"/><circle cx="41" cy="40" r="4" fill="none" stroke="var(--edge)" stroke-width="3"/><path d="M43 22 27 42" stroke="var(--edge)" stroke-width="3.5" stroke-linecap="round"/></svg>';
const IKON_TAMBAH = '<svg viewBox="0 0 64 64"><rect x="6" y="10" width="34" height="14" rx="4" fill="var(--surface)" stroke="var(--edge)" stroke-width="3"/><rect x="6" y="10" width="17" height="14" rx="4" fill="var(--sky)" stroke="var(--edge)" stroke-width="3"/><rect x="6" y="40" width="34" height="14" rx="4" fill="var(--surface)" stroke="var(--edge)" stroke-width="3"/><rect x="6" y="40" width="11" height="14" rx="4" fill="var(--pink)" stroke="var(--edge)" stroke-width="3"/><path d="M52 22v20M42 32h20" stroke="var(--mint)" stroke-width="7" stroke-linecap="round"/></svg>';
const IKON_KALI = '<svg viewBox="0 0 64 64"><rect x="8" y="8" width="48" height="48" rx="6" fill="var(--surface)"/><rect x="8" y="8" width="32" height="48" fill="var(--sky-soft)"/><rect x="8" y="8" width="48" height="24" fill="var(--pink-soft)"/><rect x="8" y="8" width="32" height="24" fill="var(--grape)"/><path d="M24 8v48M40 8v48M8 32h48" stroke="var(--edge)" stroke-width="2.5"/><rect x="8" y="8" width="48" height="48" rx="6" fill="none" stroke="var(--edge)" stroke-width="3"/></svg>';
const IKON_KPK = '<svg viewBox="0 0 64 64"><path d="M4 52H60" stroke="var(--edge)" stroke-width="4" stroke-linecap="round"/><path d="M8 48a12 12 0 0 1 24 0M32 48a12 12 0 0 1 24 0" fill="none" stroke="var(--grape)" stroke-width="3" stroke-dasharray="4 4"/><ellipse cx="32" cy="34" rx="14" ry="10" fill="var(--mint)" stroke="var(--edge)" stroke-width="3"/><circle cx="25" cy="23" r="5.5" fill="#fff" stroke="var(--edge)" stroke-width="2.5"/><circle cx="39" cy="23" r="5.5" fill="#fff" stroke="var(--edge)" stroke-width="2.5"/><circle cx="26" cy="23" r="2.2" fill="#22244A"/><circle cx="40" cy="23" r="2.2" fill="#22244A"/><path d="M27 37q5 4 10 0" fill="none" stroke="var(--edge)" stroke-width="2.5" stroke-linecap="round"/></svg>';
const IKON_OPERASI = '<svg viewBox="0 0 64 64"><rect x="6" y="6" width="24" height="24" rx="7" fill="var(--sky)" stroke="var(--edge)" stroke-width="3"/><rect x="34" y="6" width="24" height="24" rx="7" fill="var(--pink)" stroke="var(--edge)" stroke-width="3"/><rect x="6" y="34" width="24" height="24" rx="7" fill="var(--sun)" stroke="var(--edge)" stroke-width="3"/><rect x="34" y="34" width="24" height="24" rx="7" fill="var(--mint)" stroke="var(--edge)" stroke-width="3"/><path d="M18 12v12M12 18h12M41 13l10 10M51 13 41 23M12 46h12M41 46h10" stroke="var(--edge)" stroke-width="3.5" stroke-linecap="round"/><circle cx="46" cy="41" r="2" fill="var(--edge)"/><circle cx="46" cy="51" r="2" fill="var(--edge)"/></svg>';

// Beberapa batang pecahan bertumpuk sebagai gambar statis.
const tumpuk = (...isi) => `<div class="wb-visual-tumpuk">${isi.join('')}</div>`;

const IKON_PECAHAN ='<svg viewBox="0 0 64 64"><circle cx="32" cy="32" r="26" fill="var(--sun-soft)" stroke="var(--edge)" stroke-width="3"/><path d="M32 32V6A26 26 0 0 1 58 32Z" fill="var(--pink)" stroke="var(--edge)" stroke-width="3" stroke-linejoin="round"/><path d="M32 32H58A26 26 0 0 1 32 58Z" fill="var(--pink)" stroke="var(--edge)" stroke-width="3" stroke-linejoin="round"/></svg>';

export const MODUL_BILANGAN = [
  {
    id: 'pecahan-senilai', mapel: 'matematika', elemen: 'Bilangan', warna: 'pink', menit: 8, ikon: IKON_PECAHAN,
    judul: 'Mengenal pecahan & pecahan senilai',
    ringkas: 'Arsir pizza, kenali pembilang & penyebut, temukan pecahan yang sama besar.',
    topik: ['pecahan-senilai'], rumus: ['pecahan-senilai'],
    ringkasan: [
      'Pecahan [[a|b]]: **a** = pembilang (bagian yang diambil), **b** = penyebut (banyak bagian yang sama besar).',
      'Pecahan **senilai** besarnya sama walau angkanya berbeda: [[1|2]] = [[2|4]] = [[3|6]].',
      'Untuk mencari pecahan senilai, **kalikan atau bagi** pembilang **dan** penyebut dengan bilangan yang sama.',
      'Menyederhanakan pecahan: bagi pembilang dan penyebut dengan **FPB**-nya.',
    ],
    langkah: [
      {
        label: 'Apa itu pecahan?', judul: 'Pecahan adalah bagian dari keseluruhan',
        narasi: 'Bayangkan satu pizza dipotong menjadi **4 potong yang sama besar**. Kalau kamu makan 3 potong, kamu makan **[[3|4]]** pizza.',
        tugas: 'Ketuk 3 potong pizza untuk mengarsir [[3|4]] bagian.',
        widget: { tipe: 'pecahanBentuk', bentuk: 'lingkaran', target: [3, 4], penyebut: 4 },
      },
      {
        label: 'Pembilang & penyebut', judul: 'Angka atas dan angka bawah',
        narasi: 'Angka **bawah** (penyebut) menunjukkan benda dibagi menjadi berapa bagian sama besar. Angka **atas** (pembilang) menunjukkan berapa bagian yang diambil.',
        tugas: 'Buat [[2|5]]: atur batang menjadi 5 bagian, lalu arsir 2 bagian.',
        widget: { tipe: 'pecahanBentuk', bentuk: 'batang', target: [2, 5], penyebut: 3, ubahPenyebut: true },
      },
      {
        jenis: 'kuis', judul: 'Berapa bagian yang diarsir?',
        soal: 'Batang di bawah dibagi menjadi bagian yang sama besar. Pecahan untuk bagian yang **diarsir** adalah ....',
        visual: () => fracBar(3, 8),
        pilihan: ['[[3|8]]', '[[5|8]]', '[[3|5]]', '[[8|3]]'], kunci: 0,
        petunjuk: 'Hitung semua bagian dulu untuk penyebutnya, lalu hitung yang diarsir untuk pembilangnya.',
        bahas: 'Ada **8** bagian sama besar (penyebut) dan **3** yang diarsir (pembilang), jadi [[3|8]].',
      },
      {
        label: 'Pecahan senilai', judul: 'Beda angka, sama besar',
        narasi: 'Dua pecahan disebut **senilai** kalau besarnya sama, walaupun angkanya berbeda. Batang yang sama panjang artinya pecahannya senilai.',
        tugas: 'Bagi batang bawah dengan angka lain, lalu arsir sampai panjangnya sama dengan [[1|2]]. Temukan 3 pecahan senilai!',
        widget: { tipe: 'senilai', asal: [1, 2], cari: 3 },
      },
      {
        label: 'Rahasianya', judul: 'Kali atas dan bawah dengan angka yang sama',
        narasi: 'Kalau pembilang **dan** penyebut dikali dengan angka yang sama, potongannya jadi lebih kecil tetapi besarnya tetap. Itulah cara cepat mencari pecahan senilai.',
        tugas: 'Coba tekan ×2, lalu ×3, dan lihat batangnya.',
        widget: { tipe: 'kaliSenilai', asal: [2, 3], mode: 'kali', pengali: [2, 3, 4], coba: 2 },
      },
      {
        jenis: 'kuis', judul: 'Cari angka yang hilang',
        soal: '[[3|4]] = [[?|12]]\nBerapa angka yang menggantikan tanda tanya?',
        isian: { jawaban: 9 },
        petunjuk: '4 dikali berapa supaya menjadi 12? Kalikan juga pembilangnya dengan angka itu.',
        bahas: '4 × **3** = 12, maka pembilangnya juga dikali 3: 3 × 3 = **9**. Jadi [[3|4]] = [[9|12]].',
      },
      {
        label: 'Menyederhanakan', judul: 'Bagi atas dan bawah dengan angka yang sama',
        narasi: 'Kebalikannya juga bisa: **bagi** pembilang dan penyebut dengan angka yang sama untuk menyederhanakan pecahan. Paling cepat kalau dibagi dengan **FPB**-nya.',
        tugas: 'Sederhanakan [[8|12]]: coba bagi dengan 2, lalu dengan 4.',
        widget: { tipe: 'kaliSenilai', asal: [8, 12], mode: 'bagi', pengali: [2, 4], coba: 2 },
      },
      {
        jenis: 'kuis', judul: 'Pilih yang senilai',
        soal: 'Pecahan yang **senilai** dengan [[2|3]] adalah ....',
        pilihan: ['[[4|5]]', '[[6|9]]', '[[3|4]]', '[[4|9]]'], kunci: 1,
        petunjuk: 'Kalikan pembilang dan penyebut [[2|3]] dengan angka yang sama.',
        bahas: '[[2|3]] = [[2 × 3|3 × 3]] = [[6|9]]. Pilihan lain tidak bisa didapat dengan mengalikan atas dan bawah dengan angka yang sama.',
      },
      {
        jenis: 'kuis', judul: 'Benar atau salah?',
        soal: 'Tentukan **Benar** atau **Salah** untuk setiap pernyataan.',
        bs: [
          { teks: '[[1|2]] = [[5|10]]', benar: true },
          { teks: '[[2|5]] = [[4|5]]', benar: false },
          { teks: 'Bentuk paling sederhana dari [[6|8]] adalah [[3|4]].', benar: true },
        ],
        petunjuk: 'Untuk tiap pernyataan, cek apakah atas dan bawah dikali/dibagi dengan angka yang sama.',
        bahas: '[[1|2]] × [[5|5]] = [[5|10]] (benar). [[2|5]] dan [[4|5]] penyebutnya sama tetapi pembilangnya beda, jadi tidak senilai. [[6|8]] dibagi 2 menjadi [[3|4]] (benar).',
      },
    ],
  },
  // ------------------------------------------------------------------
  {
    id: 'urutan-pecahan', mapel: 'matematika', elemen: 'Bilangan', warna: 'sky', menit: 9, ikon: IKON_URUTAN,
    judul: 'Membandingkan & mengurutkan pecahan',
    ringkas: 'Letakkan pecahan di garis bilangan, samakan penyebut, lalu urutkan.',
    topik: ['urutan-pecahan', 'banding-setengah'], rumus: ['samakan-penyebut', 'kpk'],
    ringkasan: [
      'Penyebut sama: pecahan dengan **pembilang lebih besar** lebih besar. [[5|8]] > [[3|8]].',
      'Pembilang sama: pecahan dengan **penyebut lebih kecil** lebih besar. [[1|3]] > [[1|6]].',
      'Penyebut berbeda: **samakan penyebutnya** dengan KPK, lalu bandingkan pembilangnya.',
      'Di garis bilangan, makin ke **kanan** pecahannya makin besar.',
    ],
    langkah: [
      {
        label: 'Penyebut sama', judul: 'Penyebut sama? Lihat pembilangnya',
        narasi: 'Kalau penyebutnya sama, ukuran potongannya sama. Pecahan dengan **pembilang lebih besar** punya potongan lebih banyak, jadi lebih besar. Lihat: [[5|8]] lebih panjang daripada [[3|8]].',
        visual: () => tumpuk(fracBar(3, 8, F(3, 8)), fracBar(5, 8, F(5, 8))),
      },
      {
        label: 'Garis bilangan', judul: 'Letakkan pecahan di garis bilangan',
        narasi: 'Jarak dari 0 sampai 1 bisa dibagi menjadi bagian yang sama besar. Makin ke **kanan**, pecahannya makin besar.',
        tugas: 'Letakkan [[1|2]], [[1|4]], dan [[3|4]] di titik yang tepat.',
        widget: { tipe: 'garisPecahan', pecahan: [[1, 2], [1, 4], [3, 4]] },
      },
      {
        jenis: 'kuis', judul: 'Pilih tanda yang tepat',
        soal: 'Tanda yang tepat untuk [[5|9]] ... [[7|9]] adalah ....',
        pilihan: ['<', '>', '='], kunci: 0,
        petunjuk: 'Penyebutnya sama. Bandingkan pembilangnya saja.',
        bahas: 'Penyebutnya sama (9), jadi bandingkan pembilang: 5 lebih kecil dari 7. Maka [[5|9]] < [[7|9]].',
      },
      {
        label: 'Pembilang sama', judul: 'Pembilang sama? Lihat penyebutnya',
        narasi: 'Kalau pembilangnya sama, lihat penyebutnya. Makin besar penyebut, potongannya makin **kecil**. Jadi [[1|3]] lebih besar daripada [[1|6]].',
        tugas: 'Letakkan [[1|3]], [[1|6]], dan [[2|3]] di garis bilangan.',
        widget: { tipe: 'garisPecahan', pecahan: [[1, 3], [1, 6], [2, 3]] },
      },
      {
        label: 'Penyebut berbeda', judul: 'Samakan penyebutnya dulu',
        narasi: 'Kalau penyebutnya berbeda, ubah kedua pecahan menjadi pecahan senilai dengan penyebut yang sama. Pakai **KPK** dari penyebutnya, lalu bandingkan pembilangnya.',
        tugas: 'Tekan "Samakan penyebutnya", lalu pilih tanda yang tepat untuk [[2|3]] dan [[3|4]].',
        widget: { tipe: 'bandingPecahan', a: [2, 3], b: [3, 4] },
      },
      {
        jenis: 'kuis', judul: 'Samakan penyebutnya',
        soal: 'Untuk membandingkan [[3|4]] dan [[5|6]], kedua penyebut diubah menjadi 12.\n[[3|4]] = [[?|12]]. Berapa angka yang menggantikan tanda tanya?',
        isian: { jawaban: 9 },
        petunjuk: '4 dikali 3 menjadi 12. Kalikan juga pembilangnya dengan 3.',
        bahas: '[[3|4]] = [[3 × 3|4 × 3]] = [[9|12]], sedangkan [[5|6]] = [[10|12]]. Jadi [[3|4]] < [[5|6]].',
      },
      {
        label: 'Mengurutkan', judul: 'Urutkan dari yang terkecil',
        narasi: 'Untuk mengurutkan banyak pecahan, samakan semua penyebutnya atau bayangkan panjang batangnya. Setelah itu, urutkan pembilangnya.',
        tugas: 'Ketuk kartu pecahan mulai dari yang terkecil.',
        widget: { tipe: 'urutkanPecahan', pecahan: [[2, 3], [1, 2], [1, 6], [3, 4]], arah: 'naik' },
      },
      {
        jenis: 'kuis', judul: 'Urutan dari yang terkecil',
        soal: 'Urutan pecahan [[3|5]], [[1|2]], dan [[7|10]] dari yang **terkecil** adalah ....',
        pilihan: ['[[1|2]], [[3|5]], [[7|10]]', '[[3|5]], [[1|2]], [[7|10]]', '[[7|10]], [[3|5]], [[1|2]]', '[[1|2]], [[7|10]], [[3|5]]'], kunci: 0,
        petunjuk: 'Ubah semua pecahan menjadi per sepuluh (penyebut 10).',
        bahas: '[[3|5]] = [[6|10]], [[1|2]] = [[5|10]], dan [[7|10]] tetap. Urutan pembilangnya 5, 6, 7, jadi [[1|2]], [[3|5]], [[7|10]].',
      },
      {
        jenis: 'kuis', judul: 'Benar atau salah?',
        soal: 'Tentukan **Benar** atau **Salah** untuk setiap pernyataan.',
        bs: [
          { teks: '[[2|5]] < [[3|5]]', benar: true },
          { teks: '[[1|4]] > [[1|3]]', benar: false },
          { teks: '[[5|8]] > [[1|2]]', benar: true },
        ],
        petunjuk: 'Ingat: pembilang sama, penyebut lebih kecil berarti lebih besar.',
        bahas: '[[2|5]] < [[3|5]] karena 2 < 3 (benar). [[1|4]] lebih kecil dari [[1|3]], karena potongan perempat lebih kecil (salah). [[1|2]] = [[4|8]], jadi [[5|8]] > [[1|2]] (benar).',
      },
    ],
  },
  // ------------------------------------------------------------------
  {
    id: 'desimal-persen', mapel: 'matematika', elemen: 'Bilangan', warna: 'grape', menit: 10, ikon: IKON_PERSEN,
    judul: 'Pecahan, desimal, persen & diskon',
    ringkas: 'Arsir kisi seratus, ubah pecahan menjadi persen, dan hitung harga diskon.',
    topik: ['pecahan-desimal-persen', 'diskon'], rumus: ['persen', 'diskon'],
    ringkasan: [
      '**Persen** artinya per seratus: 35% = [[35|100]].',
      'Ubah penyebut menjadi **100**: [[3|4]] = [[75|100]] = 0,75 = 75%.',
      'Desimal dua angka di belakang koma = per seratus: 0,25 = [[25|100]] = 25%.',
      '**Potongan** = persen diskon × harga awal. **Yang dibayar** = harga awal − potongan.',
    ],
    langkah: [
      {
        label: 'Per seratus', judul: 'Persen artinya "per seratus"',
        narasi: '**Persen** (%) artinya per seratus. 25% berarti 25 dari 100 bagian. Kisi ini punya 100 kotak, jadi setiap kotak bernilai 1%.',
        tugas: 'Arsir kotak sampai 25%. Kamu bisa menyeret jari untuk mengarsir banyak kotak sekaligus.',
        widget: { tipe: 'kisi100', target: 25 },
      },
      {
        label: 'Desimal', judul: 'Desimal juga bisa per seratus',
        narasi: 'Angka di belakang koma menunjukkan persepuluhan dan perseratusan. Jadi 0,6 = [[6|10]] = [[60|100]] = 60%.',
        tugas: 'Arsir kisi sampai desimalnya menjadi 0,60.',
        widget: { tipe: 'kisi100', target: 60 },
      },
      {
        label: 'Rantai ajaib', judul: 'Pecahan → desimal → persen',
        narasi: 'Untuk mengubah pecahan menjadi desimal atau persen, jadikan penyebutnya **100** dulu. Setelah itu tinggal dibaca!',
        tugas: 'Pilih satu pecahan, lalu jalankan rantainya sampai persen. Lakukan untuk 2 pecahan.',
        widget: { tipe: 'rantaiKonversi', pecahan: [[3, 4], [2, 5], [7, 20]], coba: 2 },
      },
      {
        jenis: 'kuis', judul: 'Ubah ke persen',
        soal: '[[2|5]] = ... %',
        isian: { jawaban: 40, satuan: '%' },
        petunjuk: '5 dikali 20 menjadi 100. Kalikan juga pembilangnya dengan 20.',
        bahas: '[[2|5]] = [[2 × 20|5 × 20]] = [[40|100]] = **40%**.',
      },
      {
        jenis: 'kuis', judul: 'Desimal ke pecahan',
        soal: 'Bilangan **0,75** sama dengan ....',
        pilihan: ['[[3|4]]', '[[7|5]]', '[[75|10]]', '[[1|75]]'], kunci: 0,
        petunjuk: '0,75 dibaca "tujuh puluh lima per seratus".',
        bahas: '0,75 = [[75|100]]. Kalau pembilang dan penyebutnya dibagi 25, hasilnya [[3|4]].',
      },
      {
        label: 'Diskon', judul: 'Diskon artinya potongan harga',
        narasi: 'Diskon 25% artinya harga dipotong [[25|100]] dari harga awal. Yang dibayar adalah harga awal dikurangi potongannya.',
        tugas: 'Geser diskonnya sampai harga yang dibayar menjadi Rp60.000.',
        widget: { tipe: 'labelHarga', harga: 80000, targetAkhir: 60000 },
      },
      {
        jenis: 'kuis', judul: 'Hitung harga setelah diskon',
        soal: 'Harga sebuah tas Rp120.000. Toko memberi diskon 25%.\nBerapa rupiah yang harus dibayar?',
        isian: { jawaban: 90000, satuan: 'rupiah' },
        petunjuk: 'Hitung dulu potongannya: 25% dari 120.000 = [[25|100]] × 120.000.',
        bahas: 'Potongan = [[25|100]] × 120.000 = **30.000**. Yang dibayar = 120.000 − 30.000 = **Rp90.000**.',
      },
      {
        jenis: 'kuis', judul: 'Benar atau salah?',
        soal: 'Tentukan **Benar** atau **Salah** untuk setiap pernyataan.',
        bs: [
          { teks: '[[1|2]] = 50%', benar: true },
          { teks: '0,4 = 4%', benar: false },
          { teks: 'Diskon 10% dari Rp50.000 adalah Rp5.000.', benar: true },
        ],
        petunjuk: 'Ubah semuanya menjadi per seratus dulu.',
        bahas: '[[1|2]] = [[50|100]] = 50% (benar). 0,4 = [[40|100]] = 40%, bukan 4% (salah). 10% × 50.000 = 5.000 (benar).',
      },
    ],
  },
  // ------------------------------------------------------------------
  {
    id: 'tambah-kurang-pecahan', mapel: 'matematika', elemen: 'Bilangan', warna: 'mint', menit: 11, ikon: IKON_TAMBAH,
    judul: 'Penjumlahan & pengurangan pecahan',
    ringkas: 'Gabungkan potongan, samakan penyebut dengan KPK, dan ubah pecahan campuran.',
    topik: ['tambah-kurang-pecahan'], rumus: ['samakan-penyebut', 'pecahan-campuran', 'kpk'],
    ringkasan: [
      'Penyebut sama: **jumlahkan atau kurangkan pembilangnya**, penyebutnya tetap.',
      'Penyebut berbeda: samakan dulu dengan **KPK** dari penyebutnya.',
      'Penyebut **tidak** ikut dijumlah atau dikurang.',
      'Pecahan campuran: 2 [[1|4]] = [[2 × 4 + 1|4]] = [[9|4]].',
    ],
    langkah: [
      {
        label: 'Penyebut sama', judul: 'Jumlahkan potongannya',
        narasi: 'Kalau penyebutnya sama, potongannya sama besar. Kita tinggal menjumlahkan banyak potongannya (pembilang). **Penyebutnya tetap.**',
        tugas: 'Ketuk potongan [[3|7]] satu per satu untuk memindahkannya ke batang hasil.',
        widget: { tipe: 'gabungPecahan', mode: 'tambah', a: 2, b: 3, d: 7 },
      },
      {
        jenis: 'kuis', judul: 'Coba hitung',
        soal: '[[3|8]] + [[4|8]] = [[?|8]]',
        isian: { jawaban: 7 },
        petunjuk: 'Penyebutnya sama, jumlahkan pembilangnya saja.',
        bahas: '3 + 4 = **7**, penyebutnya tetap 8. Jadi [[3|8]] + [[4|8]] = [[7|8]].',
      },
      {
        label: 'Pengurangan', judul: 'Mengurangi: ambil potongannya',
        narasi: 'Pengurangan juga sama: penyebutnya tetap, pembilangnya dikurangi.',
        tugas: 'Ambil 2 potong dari [[5|6]] dengan mengetuknya.',
        widget: { tipe: 'gabungPecahan', mode: 'kurang', a: 5, b: 2, d: 6 },
      },
      {
        label: 'Penyebut berbeda', judul: 'Penyebut berbeda? Samakan dulu',
        narasi: '[[1|2]] dan [[1|3]] tidak bisa langsung dijumlah karena ukuran potongannya berbeda. Ubah keduanya ke penyebut yang sama, paling mudah pakai **KPK** dari penyebutnya.',
        tugas: 'Pilih penyebut baru yang paling kecil untuk [[1|2]] + [[1|3]].',
        widget: { tipe: 'samakanPenyebut', a: [1, 2], b: [1, 3], op: '+', pilihan: [5, 6, 12] },
      },
      {
        jenis: 'kuis', judul: 'Jumlahkan',
        soal: '[[1|4]] + [[2|3]] = ....',
        pilihan: ['[[3|7]]', '[[11|12]]', '[[3|12]]', '[[8|12]]'], kunci: 1,
        petunjuk: 'KPK dari 4 dan 3 adalah 12. Ubah kedua pecahan ke per dua belas.',
        bahas: '[[1|4]] = [[3|12]] dan [[2|3]] = [[8|12]]. Jadi [[3|12]] + [[8|12]] = [[11|12]]. Ingat, penyebutnya **tidak** dijumlahkan!',
      },
      {
        label: 'Pengurangan', judul: 'Mengurangi pecahan berpenyebut beda',
        narasi: 'Caranya sama: samakan penyebutnya dulu, baru kurangkan pembilangnya.',
        tugas: 'Pilih penyebut bersama yang paling kecil untuk [[3|4]] − [[1|6]].',
        widget: { tipe: 'samakanPenyebut', a: [3, 4], b: [1, 6], op: '−', pilihan: [10, 12, 24] },
      },
      {
        label: 'Pecahan campuran', judul: 'Pecahan campuran jadi pecahan biasa',
        narasi: '2 [[1|4]] artinya 2 utuh ditambah [[1|4]]. Supaya mudah dihitung, ubah menjadi pecahan biasa dengan memotong yang utuh menjadi perempatan.',
        tugas: 'Potong yang utuh, lalu ketuk setiap potongan yang diarsir untuk menghitungnya.',
        widget: { tipe: 'campuran', w: 2, n: 1, d: 4 },
      },
      {
        jenis: 'kuis', judul: 'Ubah pecahan campuran',
        soal: '1 [[2|5]] = [[?|5]]',
        isian: { jawaban: 7 },
        petunjuk: '1 utuh = [[5|5]]. Tambahkan 2 potong lagi.',
        bahas: '1 × 5 + 2 = **7**, jadi 1 [[2|5]] = [[7|5]].',
      },
      {
        jenis: 'kuis', judul: 'Soal cerita',
        soal: 'Ibu punya 2 [[1|2]] kg tepung. Sebanyak 1 [[1|4]] kg dipakai untuk membuat kue.\nSisa tepung Ibu adalah ....',
        pilihan: ['1 [[1|4]] kg', '1 [[1|2]] kg', '3 [[3|4]] kg', '[[3|4]] kg'], kunci: 0,
        petunjuk: '"Dipakai" berarti dikurangi. Ubah ke pecahan biasa berpenyebut 4.',
        bahas: '2 [[1|2]] = [[10|4]] dan 1 [[1|4]] = [[5|4]]. [[10|4]] − [[5|4]] = [[5|4]] = **1 [[1|4]] kg**.',
      },
    ],
  },
  // ------------------------------------------------------------------
  {
    id: 'kali-bagi-pecahan', mapel: 'matematika', elemen: 'Bilangan', warna: 'orange', menit: 11, ikon: IKON_KALI,
    judul: 'Perkalian & pembagian pecahan',
    ringkas: 'Lihat perkalian pecahan dengan model luas, potong kue untuk membagi.',
    topik: ['kali-bagi-pecahan'], rumus: ['kali-pecahan', 'bagi-pecahan'],
    ringkasan: [
      'Bilangan × pecahan: kalikan dengan **pembilangnya**: 3 × [[2|5]] = [[6|5]] = 1 [[1|5]].',
      'Pecahan × pecahan: **pembilang × pembilang**, **penyebut × penyebut**.',
      'Membagi pecahan: **kalikan dengan kebalikannya**: [[a|b]] : [[c|d]] = [[a|b]] × [[d|c]].',
      '2 : [[1|4]] = 8, karena ada 8 potong [[1|4]] di dalam 2.',
    ],
    langkah: [
      {
        label: 'Bilangan × pecahan', judul: '3 × [[2|5]] itu penjumlahan berulang',
        narasi: '3 × [[2|5]] artinya [[2|5]] + [[2|5]] + [[2|5]]. Penyebutnya tetap, pembilangnya dikali 3, jadi hasilnya [[6|5]] = 1 [[1|5]].',
        visual: () => tumpuk(fracBar(2, 5, F(2, 5)), fracBar(2, 5, F(2, 5)), fracBar(2, 5, F(2, 5))),
      },
      {
        jenis: 'kuis', judul: 'Coba hitung',
        soal: '4 × [[2|3]] = [[?|3]]',
        isian: { jawaban: 8 },
        petunjuk: 'Kalikan 4 dengan pembilangnya. Penyebutnya tetap.',
        bahas: '4 × 2 = **8**, penyebutnya tetap 3. Jadi 4 × [[2|3]] = [[8|3]] = 2 [[2|3]].',
      },
      {
        label: 'Pecahan × pecahan', judul: 'Model luas: arsiran yang bertumpuk',
        narasi: '[[2|3]] × [[3|4]] artinya "[[3|4]] dari [[2|3]]". Arsir [[2|3]] secara tegak dan [[3|4]] secara mendatar. Bagian yang bertumpuk (ungu) adalah hasilnya.',
        tugas: 'Atur pecahan 1 menjadi [[2|3]] dan pecahan 2 menjadi [[3|4]].',
        widget: { tipe: 'modelLuas', target: [[2, 3], [3, 4]] },
      },
      {
        label: 'Aturannya', judul: 'Atas × atas, bawah × bawah',
        narasi: 'Banyak kotak ungu = pembilang × pembilang. Banyak semua kotak = penyebut × penyebut. Jadi [[a|b]] × [[c|d]] = [[a × c|b × d]].',
        tugas: 'Buat [[1|2]] × [[3|5]] dan lihat hasilnya.',
        widget: { tipe: 'modelLuas', target: [[1, 2], [3, 5]] },
      },
      {
        jenis: 'kuis', judul: 'Kalikan pecahan',
        soal: '[[3|4]] × [[2|5]] = ....',
        pilihan: ['[[6|20]]', '[[5|9]]', '[[8|15]]', '[[5|20]]'], kunci: 0,
        petunjuk: 'Kalikan pembilang dengan pembilang, penyebut dengan penyebut.',
        bahas: '3 × 2 = 6 dan 4 × 5 = 20, jadi hasilnya [[6|20]] (bisa disederhanakan menjadi [[3|10]]).',
      },
      {
        label: 'Membagi pecahan', judul: 'Ada berapa [[1|4]] di dalam 2?',
        narasi: '2 : [[1|4]] artinya: kalau 2 kue dipotong menjadi [[1|4]]-an, ada berapa potong? Ayo kita potong!',
        tugas: 'Potong batangnya, lalu pilih banyak potongannya.',
        widget: { tipe: 'bagiPecahan', n: 2, d: 4, pilihan: [2, 6, 8] },
      },
      {
        label: 'Kali kebalikan', judul: 'Rahasia membagi: balik lalu kalikan',
        narasi: 'Membagi dengan pecahan sama dengan **mengali dengan kebalikannya**. Kebalikan [[1|2]] adalah [[2|1]] (atas dan bawah ditukar).',
        tugas: 'Tekan tombol 1, lalu tombol 2 untuk menghitung [[3|4]] : [[1|2]].',
        widget: { tipe: 'balikPecahan', a: [3, 4], b: [1, 2] },
      },
      {
        jenis: 'kuis', judul: 'Bagi pecahan',
        soal: '[[2|3]] : [[1|6]] = ?',
        isian: { jawaban: 4 },
        petunjuk: 'Balik [[1|6]] menjadi [[6|1]], lalu kalikan.',
        bahas: '[[2|3]] × [[6|1]] = [[12|3]] = **4**. Jadi ada 4 potong [[1|6]] di dalam [[2|3]].',
      },
      {
        jenis: 'kuis', judul: 'Benar atau salah?',
        soal: 'Tentukan **Benar** atau **Salah** untuk setiap pernyataan.',
        bs: [
          { teks: '[[1|2]] × [[1|3]] = [[1|6]]', benar: true },
          { teks: '6 : [[1|2]] = 3', benar: false },
          { teks: 'Kebalikan dari [[4|5]] adalah [[5|4]].', benar: true },
        ],
        petunjuk: 'Untuk pembagian, ingat "balik lalu kalikan".',
        bahas: '1 × 1 = 1 dan 2 × 3 = 6, jadi [[1|6]] (benar). 6 : [[1|2]] = 6 × 2 = 12, bukan 3 (salah). Kebalikan [[4|5]] adalah [[5|4]] (benar).',
      },
    ],
  },
  // ------------------------------------------------------------------
  {
    id: 'kpk-fpb', mapel: 'matematika', elemen: 'Bilangan', warna: 'sun', menit: 12, ikon: IKON_KPK,
    judul: 'KPK, FPB, faktor & kelipatan',
    ringkas: 'Lompatkan katak untuk KPK, susun titik untuk faktor, dan temukan FPB.',
    topik: ['kpk', 'fpb', 'faktor-kelipatan'], rumus: ['kelipatan', 'kpk', 'faktor', 'fpb'],
    ringkasan: [
      '**Kelipatan** sebuah bilangan: bilangan itu dikali 1, 2, 3, dan seterusnya.',
      '**KPK** = kelipatan persekutuan yang paling kecil. Kata kunci: **bersamaan lagi**, **bertemu lagi**.',
      '**Faktor** = bilangan yang membagi habis. **FPB** = faktor persekutuan yang paling besar.',
      'Kata kunci FPB: dibagi **sama banyak**, **sebanyak-banyaknya** atau sepanjang-panjangnya.',
    ],
    langkah: [
      {
        label: 'Kelipatan', judul: 'Kelipatan adalah hasil lompatan',
        narasi: 'Katak ini selalu melompat 3 langkah. Tempat ia mendarat (3, 6, 9, ...) disebut **kelipatan 3**, yaitu 3 × 1, 3 × 2, 3 × 3, dan seterusnya.',
        tugas: 'Lompatkan katak 5 kali.',
        widget: { tipe: 'lompatKatak', a: 3, lompat: 5, maks: 18 },
      },
      {
        label: 'KPK', judul: 'Di mana kedua katak bertemu?',
        narasi: 'Katak hijau melompat 4 langkah, katak oranye melompat 6 langkah. Angka tempat keduanya mendarat disebut kelipatan persekutuan. Yang paling kecil disebut **KPK**.',
        tugas: 'Lompatkan kedua katak sampai mendarat di angka yang sama.',
        widget: { tipe: 'lompatKatak', a: 4, b: 6, maks: 36 },
      },
      {
        jenis: 'kuis', judul: 'Cari KPK',
        soal: 'KPK dari 6 dan 8 adalah ....',
        isian: { jawaban: 24 },
        petunjuk: 'Tulis kelipatan 8: 8, 16, 24, ... Mana yang juga kelipatan 6?',
        bahas: 'Kelipatan 6: 6, 12, 18, **24**, ... Kelipatan 8: 8, 16, **24**, ... Yang sama paling kecil adalah **24**.',
      },
      {
        label: 'Faktor', judul: 'Faktor: susun menjadi barisan rapi',
        narasi: '**Faktor** adalah bilangan yang membagi habis. 12 kelereng bisa disusun rapi menjadi 3 baris berisi 4, jadi 3 dan 4 adalah faktor 12.',
        tugas: 'Ubah banyak baris sampai semua faktor 12 ditemukan.',
        widget: { tipe: 'susunFaktor', n: 12 },
      },
      {
        label: 'FPB', judul: 'FPB: faktor sama yang terbesar',
        narasi: 'Faktor yang dimiliki dua bilangan sekaligus disebut **faktor persekutuan**. Yang paling besar disebut **FPB**.',
        tugas: 'Ketuk semua faktor yang ada di kedua daftar.',
        widget: { tipe: 'faktorSekutu', a: 12, b: 18 },
      },
      {
        jenis: 'kuis', judul: 'Cari FPB',
        soal: 'FPB dari 16 dan 24 adalah ....',
        pilihan: ['4', '8', '48', '2'], kunci: 1,
        petunjuk: 'Tulis faktor 16 dan faktor 24, lalu cari yang sama dan paling besar.',
        bahas: 'Faktor 16: 1, 2, 4, **8**, 16. Faktor 24: 1, 2, 3, 4, 6, **8**, 12, 24. Yang sama dan paling besar adalah **8**.',
      },
      {
        label: 'KPK atau FPB?', judul: 'Kenali dari kata kuncinya',
        narasi: 'Di soal cerita, "**bersamaan lagi**" atau "**bertemu lagi**" biasanya berarti KPK. "Dibagi **sama banyak**, **sebanyak-banyaknya**" biasanya berarti FPB.',
        tugas: 'Masukkan setiap kartu cerita ke kotak KPK atau FPB.',
        widget: {
          tipe: 'pilahCerita', kartu: [
            { teks: 'Lampu merah berkedip setiap 4 detik, lampu hijau setiap 6 detik. Kapan keduanya <b>berkedip bersamaan lagi</b>?', jenis: 'kpk', singkat: 'Lampu berkedip bersamaan lagi', alasan: '"Bersamaan lagi" artinya mencari kelipatan yang sama → KPK.', petunjuk: 'Cari kata kuncinya: "bersamaan lagi".' },
            { teks: 'Ada 24 pensil dan 36 buku. Semuanya <b>dibagikan sama banyak</b> kepada <b>sebanyak-banyaknya</b> anak. Ada berapa anak?', jenis: 'fpb', singkat: 'Pensil & buku dibagi sama banyak', alasan: '"Dibagi sama banyak, sebanyak-banyaknya" → FPB.', petunjuk: 'Barangnya dibagi-bagi sama banyak. Itu ciri FPB.' },
            { teks: 'Ani les renang setiap 3 hari, Budi setiap 5 hari. Hari ini mereka les bersama. Kapan mereka <b>bertemu lagi</b>?', jenis: 'kpk', singkat: 'Les renang bertemu lagi', alasan: '"Bertemu lagi" → KPK.', petunjuk: 'Ada kata "bertemu lagi".' },
            { teks: 'Pita merah 30 cm dan pita biru 45 cm dipotong menjadi potongan yang <b>sama panjang</b> dan <b>sepanjang-panjangnya</b>. Berapa panjang setiap potongan?', jenis: 'fpb', singkat: 'Pita dipotong sama panjang', alasan: '"Sama panjang, sepanjang-panjangnya" → FPB.', petunjuk: 'Pitanya dipotong-potong sama panjang. Itu ciri FPB.' },
          ],
        },
      },
      {
        jenis: 'kuis', judul: 'Soal cerita KPK',
        soal: 'Lampu A berkedip setiap 6 detik dan lampu B setiap 10 detik. Keduanya baru saja berkedip bersamaan.\nMereka akan berkedip bersamaan lagi setelah ... detik.',
        pilihan: ['16', '30', '60', '2'], kunci: 1,
        petunjuk: '"Bersamaan lagi" → cari KPK dari 6 dan 10.',
        bahas: 'Kelipatan 6: 6, 12, 18, 24, **30**. Kelipatan 10: 10, 20, **30**. KPK = **30** detik.',
      },
      {
        jenis: 'kuis', judul: 'Soal cerita FPB',
        soal: 'Bu Guru punya 24 apel dan 36 jeruk. Semua buah dimasukkan ke kantong dengan isi sama banyak, sebanyak-banyaknya kantong.\nBanyak kantong yang dibutuhkan adalah ....',
        pilihan: ['6', '12', '72', '4'], kunci: 1,
        petunjuk: '"Sama banyak, sebanyak-banyaknya" → cari FPB dari 24 dan 36.',
        bahas: 'FPB(24, 36) = **12**, jadi ada 12 kantong. Setiap kantong berisi 2 apel dan 3 jeruk.',
      },
    ],
  },
  // ------------------------------------------------------------------
  {
    id: 'operasi-hitung', mapel: 'matematika', elemen: 'Bilangan', warna: 'pink', menit: 9, ikon: IKON_OPERASI,
    judul: 'Operasi hitung bilangan cacah',
    ringkas: 'Kerjakan operasi campuran dengan urutan yang benar dan ubah cerita menjadi hitungan.',
    topik: ['bilangan-cacah', 'cukup-uang'], rumus: ['urutan-operasi'],
    ringkasan: [
      'Urutan mengerjakan: **kurung** → **kali dan bagi** → **tambah dan kurang**.',
      'Operasi yang setingkat dikerjakan dari **kiri** ke kanan.',
      'Soal cerita: baca pelan-pelan, buat modelnya, lalu tulis kalimat matematikanya.',
      'Pembagian bersisa di soal bus atau kotak: sisanya tetap butuh **satu tempat lagi**.',
    ],
    langkah: [
      {
        label: 'Urutan operasi', judul: 'Kali dan bagi dikerjakan dulu',
        narasi: 'Kalau ada campuran tambah, kurang, kali, dan bagi, kerjakan **kali dan bagi** lebih dulu. Setelah itu baru tambah dan kurang.',
        tugas: 'Ketuk operasi yang harus dikerjakan lebih dulu sampai tersisa satu bilangan.',
        widget: { tipe: 'urutanOperasi', ekspresi: '12 + 6 × 3' },
      },
      {
        label: 'Dari kiri', judul: 'Yang setingkat: dari kiri ke kanan',
        narasi: 'Kali dan bagi itu **setingkat**, begitu juga tambah dan kurang. Kalau setingkat, kerjakan yang paling **kiri** lebih dulu.',
        tugas: 'Selesaikan 48 : 6 × 2 − 5 dengan urutan yang benar.',
        widget: { tipe: 'urutanOperasi', ekspresi: '48 : 6 × 2 − 5' },
      },
      {
        jenis: 'kuis', judul: 'Hitung dengan urutan yang benar',
        soal: '20 − 4 × 3 + 2 = ?',
        isian: { jawaban: 10 },
        petunjuk: 'Kerjakan 4 × 3 lebih dulu.',
        bahas: '4 × 3 = 12 dulu. Lalu dari kiri: 20 − 12 = 8, kemudian 8 + 2 = **10**.',
      },
      {
        label: 'Tanda kurung', judul: 'Kurung dikerjakan paling dulu',
        narasi: 'Tanda kurung seperti berkata "kerjakan aku dulu!". Selesaikan isi kurung, baru kali/bagi, lalu tambah/kurang.',
        tugas: 'Selesaikan (15 − 5) × 4 + 6 : 3.',
        widget: { tipe: 'urutanOperasi', ekspresi: '(15 − 5) × 4 + 6 : 3' },
      },
      {
        jenis: 'kuis', judul: 'Ada kurungnya',
        soal: '36 : (4 + 2) × 3 = ....',
        pilihan: ['18', '2', '27', '15'], kunci: 0,
        petunjuk: 'Kerjakan isi kurung dulu, lalu bagi dan kali dari kiri.',
        bahas: '(4 + 2) = 6 dulu. Lalu dari kiri: 36 : 6 = 6, kemudian 6 × 3 = **18**.',
      },
      {
        label: 'Soal cerita', judul: 'Ubah cerita menjadi kalimat matematika',
        narasi: 'Baca ceritanya pelan-pelan, lalu bayangkan modelnya. Model batang membantu kita tahu operasi apa yang dipakai dan urutannya.',
        tugas: 'Pilih kalimat matematika yang cocok dengan ceritanya.',
        widget: {
          tipe: 'modelBatang',
          cerita: 'Pak Budi membeli <b>4 kotak</b> telur. Setiap kotak berisi <b>12 butir</b>. Di jalan, <b>5 butir</b> pecah. Berapa butir telur yang masih bagus?',
          kelompok: 4, isi: 12, satuan: 'kotak', kurang: 5, labelKurang: 'dikurangi yang pecah',
          pilihan: ['4 × 12 − 5', '4 + 12 − 5', '4 × (12 − 5)'], kunci: 0,
          salah: { 1: '4 + 12 artinya 4 butir ditambah 12 butir. Padahal ada 4 kotak yang masing-masing berisi 12 butir.', 2: 'Itu artinya di setiap kotak ada 5 telur yang pecah. Di cerita, yang pecah hanya 5 butir semuanya.' },
          langkah: ['4 × 12 = 48 butir', '48 − 5 = 43 butir'], hasil: 43,
          pesan: 'Tepat! 4 × 12 − 5 = 48 − 5 = **43 butir** telur yang masih bagus.',
        },
      },
      {
        jenis: 'kuis', judul: 'Soal cerita',
        soal: 'Sebanyak 125 siswa dan 7 guru akan naik bus. Satu bus memuat 30 orang.\nPaling sedikit, berapa bus yang dibutuhkan?',
        pilihan: ['4 bus', '5 bus', '6 bus', '132 bus'], kunci: 1,
        petunjuk: 'Jumlahkan semua orang dulu, lalu bagi 30. Sisa orang tetap butuh bus.',
        bahas: '125 + 7 = 132 orang. 132 : 30 = 4 sisa 12. Sisa 12 orang tetap butuh bus, jadi **5 bus**.',
      },
      {
        jenis: 'kuis', judul: 'Benar atau salah?',
        soal: 'Tentukan **Benar** atau **Salah** untuk setiap pernyataan.',
        bs: [
          { teks: '10 + 5 × 2 = 30', benar: false },
          { teks: '(10 + 5) × 2 = 30', benar: true },
          { teks: '24 : 4 : 2 = 3', benar: true },
        ],
        petunjuk: 'Perhatikan kurung, lalu kali/bagi, lalu tambah/kurang.',
        bahas: '10 + 5 × 2 = 10 + 10 = 20, bukan 30 (salah). (10 + 5) × 2 = 15 × 2 = 30 (benar). 24 : 4 : 2 = 6 : 2 = 3 (benar).',
      },
    ],
  },
];
